// Defensive guard for Chart.js's animator.
//
// Chart.js v4 keeps a global animator that ticks every active chart on each
// requestAnimationFrame. If a chart's canvas has been removed from the DOM
// (e.g. a v-if component unmounting) before its destroy() call has fully
// drained the animator, the next tick lands inside `clearCanvas` and crashes
// with "Cannot read properties of null (reading 'getContext')".
//
// Component-level fixes (calling chart.stop() before destroy()) are the real
// remedy. This patch is a runtime safety net: if a chart's canvas or context
// is missing at draw time, we silently no-op and remove it from the animator
// instead of throwing.

import { Chart } from "chart.js";

const originalDraw = Chart.prototype.draw;

Chart.prototype.draw = function patchedDraw(...args) {
  // Bail out if the chart was orphaned before we got here.
  if (!this.canvas || !this.ctx) {
    try {
      // Best-effort: pull this chart out of the animator so we don't keep
      // hitting this path every frame.
      this.stop();
    } catch (e) {
      /* noop */
    }
    return;
  }
  return originalDraw.apply(this, args);
};
